'use client';

import { motion, AnimatePresence } from 'motion/react';
import { useEffect, useState, useTransition } from 'react';

interface RotatingTickerProps {
  items: string[];
  interval?: number;
  style?: React.CSSProperties;
}

const RotatingTicker = ({ items, interval = 3000, style = {} }: RotatingTickerProps) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    const tickerInterval = setInterval(() => {
      startTransition(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
      });
    }, interval);

    return () => clearInterval(tickerInterval);
  }, [items.length, interval, startTransition]);

  const variants = {
    enter: {
      y: 20,
      opacity: 0,
    },
    active: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.3 },
    },
    exit: {
      y: -20,
      opacity: 0,
      transition: { duration: 0.3 },
    }
  };

  return (
    <div>
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          variants={variants}
          initial="enter"
          animate="active"
          exit="exit"
          style={style}
        >
          {items[currentIndex]}
        </motion.div>
      </AnimatePresence>
    </div>
  )
};

export default RotatingTicker;